import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';
import { Button } from '../Button';
import OverviewStepItem from '../OverviewStepItem/';

export const OverviewStepContent = ({
  isDashboard,
  currentStep,
  currentOverviewSteps,
  handleNextStep,
  handleGoToAnswer,
  onboardingFullSteps,
  overviewInfoIndex,
}) => (
  <div>
    <div
      className={`overview-step__content ${
        isDashboard ? 'overview-step__content--dashboard' : ''
      }`}
    >
      {currentOverviewSteps.map((info, generalIndex) => {
        const onboardingStepsInfo =
          onboardingFullSteps[info.key].onboardingSteps;

        const notDone = onboardingStepsInfo
          .filter(s => !s.disabled)
          .find(s => s.status !== 'done');

        let { status } = info;

        if (info.key === currentStep) {
          status = 'current';
        } else if (info.key !== 'basic_information' && status !== 'current') {
          status = isNil(notDone) ? 'done' : 'empty';
        }

        const dashboardClass = isDashboard ? '-dashboard' : '';

        return (
          <div
            key={String(generalIndex)}
            className={
              generalIndex === currentOverviewSteps.length - 1
                ? `overview-step__element--last${dashboardClass}`
                : `overview-step__element--${status}${dashboardClass}`
            }
          >
            <div className="overview-step__element-header">
              <div
                className={`overview-step__element-image overview-step__element-image--${status}`}
              >
                <div
                  className={`overview-step__element-icon overview-step__element-icon--${status} overview-step__element-icon--${
                    info.key
                  }`}
                />
              </div>
              <div
                className={`overview-step__element-title overview-step__element-title--${status}`}
              >
                {info.title}
              </div>
            </div>
            <div className="overview-step__questions">
              {info.questions
                .filter(question => !question.disabled)
                .map((question, index) => (
                  <OverviewStepItem
                    key={question.key}
                    status={status}
                    info={info}
                    onboardingStepsInfo={onboardingStepsInfo}
                    question={question}
                    currentStep={currentStep}
                    overviewInfoIndex={overviewInfoIndex}
                    generalIndex={generalIndex}
                    index={index}
                    handleGoToAnswer={handleGoToAnswer}
                    dashboardClass={dashboardClass}
                  />
                ))}
            </div>
          </div>
        );
      })}
    </div>
    <div className="overview-step__next-button">
      <Button
        title="START"
        onClick={handleNextStep}
        block
        rounded
        className="btn-primary px-6"
      />
    </div>
  </div>
);

OverviewStepContent.propTypes = {
  isDashboard: PropTypes.bool,
  currentStep: PropTypes.string,
  currentOverviewSteps: PropTypes.array,
  handleNextStep: PropTypes.func,
  handleGoToAnswer: PropTypes.func,
  onboardingFullSteps: PropTypes.object,
  overviewInfoIndex: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/OverviewStepContent/OverviewStepContent.js